export const Currency = {
  Locale: 'en-US',
  Type: 'USD',
  Style: 'currency',
};
